module.exports = __webpack_public_path__ + "static/media/rishabh.bf158ddb.jpg";